import { Fragment, useEffect, useState, useContext } from 'react';
import { Row, Col } from 'react-bootstrap';
import { PermintaanBahanProduksiApi } from 'api';
import { TableTransferBahanProduksi } from '../TableTransferBahanProduksi';
import { TransferBahanProduksiContext } from '../../Context';
import { TablePermintaanHW } from './TablePermintaanHW';

export const TabHardwood = () => {
  const { dataJobOrder, dataPermintaan } = useContext(
    TransferBahanProduksiContext
  );
  const id_permintaan_produksi = dataJobOrder.id_permintaan_produksi;
  const [history, setHistory] = useState([]);

  // FETCH HISTORY
  useEffect(() => {
    if (id_permintaan_produksi) {
      PermintaanBahanProduksiApi.transfer({
        id_permintaan_produksi,
        ref_bahan: 'bhw',
      })
        .then((res) => setHistory(res.data.data ?? []))
        .catch(({ response }) =>
          alert(`Gagal memuat data History Hardwood ${response.data.message}`)
        );
    }
  }, []);

  return (
    <Fragment>
      <Row className="d-flex justify-content-between align-items-end mb-1">
        <Col>
          <small>List Data Permintaan Hardwood</small>
        </Col>
      </Row>
      <TablePermintaanHW data={dataPermintaan?.hardwood ?? []} />

      <small className="mt-2">List Data Transfer Bahan Produksi</small>
      <TableTransferBahanProduksi
        tipe="editable"
        tipeTransfer="hardwood"
        data={dataPermintaan?.hardwood}
        uniqueKey="id_permintaan_produksi_hardwood"
      />

      <small className="mt-2">History Transfer Bahan Produksi</small>
      <TableTransferBahanProduksi tipe="readonly" data={history} />
    </Fragment>
  );
};
